
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Qui le fabrique?`}</em></p>
    <p>{`On connaît plus ce produit sous le nom des deux compagnies qui l’ont développé:
l’Américaine Pfizer et l’Allemande BioNTech.
`}<a parentName="p" {...{
        "href": "https://www.pfizer.fr/pfizer-et-biontech-collaborent-pour-d%C3%A9velopper-un-vaccin-potentiel-contre-le-covid-19"
      }}>{`Ces firmes collaborent déjà depuis 2018`}</a>{`
pour le développement d’un vaccin contre la grippe. Si vous voulez frimer, vous
pouvez aussi nommer cette injection Tozinameran ou BNT162b2.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;